import type { QueryClient } from '@tanstack/react-query';
export async function refreshFunding(qc:QueryClient,base:string) {
  await Promise.all([
    ...['campaigns','balance','topup','overview'].map(name=>qc.invalidateQueries({queryKey:[name]})),
    qc.invalidateQueries({queryKey:['wallets',base]}),
  ]);
}
